<template>
  <div>
    <base-drawer :open="open" :close="close" title="Selecionar cartão">
      <div class="mb_20" @click="drawers.newCard.open = !drawers.newCard.open">
        <base-add text="ADICIONAR CARTÃO" :plus="false" height="100px" />
      </div>
      <div
        v-for="(cardItem, cardIndex) in cards"
        :key="`card-${cardIndex}`"
        class="mb_20"
      >
        <base-card>
          <div class="card-item">
            <div class="brand mr_20">
              <div class="no-brand"></div>
            </div>
            <div class="number">
              <div class="title mb_10">Cartão de crédito</div>
              <div class="card-number">
                {{ cardItem.brand }} **** {{ cardItem.finalNumber }}
              </div>
            </div>
            <div class="change-card">
              <base-button
                v-if="mode == drawerMode.SELECT"
                design="four"
                text="SELECIONAR"
                @click="$emit('selectCard', cardItem)"
              />
              <base-button
                v-else-if="mode == drawerMode.DELETE"
                design="four"
                text="REMOVER"
              />
            </div>
          </div>
        </base-card>
      </div>
      <div class="d-flex align-center justify-center">
        <base-button
          v-if="mode == drawerMode.SELECT"
          design="four"
          text="REMOVER CARTÃO"
          @click="mode = drawerMode.DELETE"
        />
        <base-button
          v-else-if="mode == drawerMode.DELETE"
          design="five"
          text="CANCELAR"
          @click="mode = drawerMode.SELECT"
        />
      </div>
    </base-drawer>
    <div class="new-card-wrapper">
      <base-drawer
        :open="drawers.newCard.open"
        :close="drawers.newCard.close"
        title="Cadastrar Cartão"
      >
        <base-card>
          <div class="card-template pb_50 pt_30 px_35">
            <div class="brand d-flex justify-end mb_25">
              <div class="no-brand"></div>
            </div>
            <div class="card-number mb_30">
              {{ card.number || "0000 0000 0000 0000" }}
            </div>
            <div class="row">
              <div class="card-name col-xs-6">
                <p class="label mb_5">TITULAR DO CARTÃO</p>
                <p class="content">{{ card.name || `Titular do cartão` }}</p>
              </div>
              <div class="card-expire col-xs-6">
                <p class="label mb_5">DATA DE VALIDADE</p>
                <p class="content">{{ card.expireDate || "01/01" }}</p>
              </div>
            </div>
          </div>
          <div class="px_25 py_30">
            <base-input label="Titular do cartão" v-model="card.name" />
            <base-input
              label="Número do cartão"
              v-model="card.number"
              mask="#### #### #### ####"
              masked
            />
            <div class="row mb_30">
              <base-input
                label="Data de validade"
                class="col-xs-6"
                v-model="card.expireDate"
                mask="##/##"
              />
              <base-input
                label="Cod. de Segurança"
                class="col-xs-6"
                v-model="card.cvc"
                mask="###"
              />
            </div>
            <div>
              <base-button text="PAGAR AGORA" @click="addCard" class="w-100" />
            </div>
          </div>
        </base-card>
        <div class="d-flex align-center justify-center">
          <base-button
            design="five"
            text="VOLTAR"
            @click.prevent="closeNewDrawer"
          />
        </div>
      </base-drawer>
    </div>
  </div>
</template>
<script>
import jsonCards from "@/api/cards.json";
import BaseAdd from "@/components/Add";
import BaseDrawer from "@/components/Drawer";
import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";
import BaseInput from "@/components/Input";

const drawerMode = {
  SELECT: "select",
  DELETE: "delete",
};

export default {
  components: { BaseAdd, BaseDrawer, BaseButton, BaseCard, BaseInput },
  props: {
    open: { type: Boolean, default: false },
    close: { type: Boolean, default: false },
  },
  data() {
    return {
      drawerMode,
      mode: drawerMode.SELECT,
      drawers: {
        newCard: {
          open: false,
          close: false,
        },
      },
      cards: [],
      card: {
        name: "",
        number: "",
        cvc: "",
        expireDate: "",
      },
    };
  },
  mounted() {
    this.cards = jsonCards;
  },
  methods: {
    addCard() {
      this.drawers.newCard.close = !this.drawers.newCard.close;
      this.$emit("onCardAdded", JSON.parse(JSON.stringify(this.card)));
    },
    closeNewDrawer() {
      this.drawers.newCard.close = !this.drawers.newCard.close;
    },
  },
};
</script>
<style scoped>
.card-item .brand .no-brand {
  width: 50px;
  height: 35px;
  background: #eeeeee 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.card-item {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.card-item .number {
  flex: 1;
}

.card-item .number .title {
  text-align: left;
  font: normal normal normal 15px/18px Lato;
  letter-spacing: 0px;
  color: #aaaaaa;
  opacity: 1;
}

.card-item .number .card-number {
  text-align: left;
  font: normal normal normal 12px/15px Lato;
  letter-spacing: 0px;
  color: #bbbbbb;
  opacity: 1;
}

.card-item .change-card {
  display: flex;
  align-items: center;
}

.card-template {
  background-color: #ccebff;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}

.new-card-wrapper .card {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}

.new-card-wrapper .brand .no-brand {
  width: 50px;
  height: 35px;
  background: var(--default) 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.new-card-wrapper .card-number {
  text-align: left;
  font: normal normal 900 22px/27px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.new-card-wrapper .card-name .label,
.new-card-wrapper .card-expire .label {
  text-align: left;
  font: normal normal bold 10px/12px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.new-card-wrapper .card-name .content,
.new-card-wrapper .card-expire .content {
  text-align: left;
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}
</style>